import defaultTheme from '@/themes/default';

const state = {
  theme: {
    ...defaultTheme,
  },
};

export { state as default };
